import { useDemand2Scope } from "~/components/demand-2/useDemand2Scope"
import { api } from "~/utils/api"
import {
  type AnswerScope,
  effectiveAnswerFor,
  type FramingNode,
  type FramingQuestionId,
  NO_FRAMING_ANSWERS,
  WHOLE_COLLECTION_NODE,
} from "~/utils/demandFraming"

/**
 * One question's effective answer on `scope` (or `node`, when no scope is given), read from the
 * route's collection. Null until the answers load. One id answers for the route: a group resolves
 * through the same workspace as any member.
 */
export const useScopedFramingAnswer = (
  question: FramingQuestionId,
  node: FramingNode = WHOLE_COLLECTION_NODE,
  scopeProp?: AnswerScope,
) => {
  const { collectionIds, kind } = useDemand2Scope()
  const collectionId = collectionIds[0]
  const answersQ = api.demand2.getDemandFraming.useQuery(
    { collectionId: collectionId ?? 0 },
    { enabled: collectionId != null },
  )
  if (collectionId == null || answersQ.isLoading) return null
  const scope: AnswerScope =
    scopeProp ?? (node.groupKey === "" ? { kind: "whole" } : { kind: "node", node })
  const framing = answersQ.data ?? NO_FRAMING_ANSWERS
  return { collectionId, kind, scope, framing, ...effectiveAnswerFor(framing, question, scope) }
}
